
import { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';
import { useToolUsageLimit } from '@/hooks/useToolUsageLimit';
import { LimitReachedModal } from '@/components/LimitReachedModal';

// Route protection component - modifiée pour permettre l'accès public aux outils
export const ProtectedRoute = ({ children }: { children: ReactNode }) => {
  const { user, loading } = useAuth();
  const location = useLocation();
  const { hasReachedLimit } = useToolUsageLimit();

  if (loading) {
    return <div className="flex items-center justify-center min-h-screen">Chargement...</div>;
  }

  // Si c'est une page d'outil (dans le dossier des outils)
  const isToolPage = /^\/(todo-boost|roi-quick|profit-pilot|email-score|biz-name-gen|utm-magic|gen-persona|snippet-view|converticalc|keyword-check|evorate|funnel-flow|pagespeed-check|checklista|formugen|qrna|compressapic|canvasbuilder|shortatrack|planifica|tabliwizz|fairclick).*$/.test(location.pathname);

  // Si c'est une page d'outil, on autorise l'accès même sans être connecté
  if (isToolPage) {
    return <>{children}</>;
  }

  // Pour les autres pages, on vérifie l'authentification
  if (!user) {
    // Redirect to auth page, but save the intended destination
    return <Navigate to="/auth" state={{ from: location }} replace />;
  }

  return <>{children}</>;
};

// Redirect authenticated users away from auth page, except for reset password
export const AuthRoute = ({ children }: { children: ReactNode }) => {
  const { user, loading } = useAuth();
  const location = useLocation();
  const isResetPasswordRoute = location.pathname.includes('/reset') || location.hash.includes('type=recovery');
  
  if (loading) {
    return <div className="flex items-center justify-center min-h-screen">Chargement...</div>;
  }

  // Si l'utilisateur est connecté mais qu'il est sur la page de réinitialisation de mot de passe,
  // on le laisse accéder à cette page
  if (user && !isResetPasswordRoute) {
    return <Navigate to="/welcome" replace />;
  }

  return <>{children}</>;
};
